module.exports = __webpack_public_path__ + "img/17844_L.9c880202.png";